import { ApiPath } from "./client";
import { ISheet } from "../../types";
import ApiHandler from "./handler";

export default new ApiHandler<ISheet>(ApiPath.SHEETS, "sheetId");
